'use strict'

import EL from './elements'

// 定数
export default {
  BREAKPOINT: 768,
  SCROLL_OFFSET_LG: 0,
  SCROLL_OFFSET_SM: 0,
  SCROLL_DURATION_LG: 900,
  SCROLL_DURATION_SM: 1200,
  SCROLL_EASING_LG: 'easeInOutQuart',
  SCROLL_EASING_SM: 'easeInOutQuart',
  H: 768,
  W: 1366,
  RATE: 1366 / 768
}
